export const ru = {
  channels: {
    title: 'Каналы и слоты',
    subtitle: 'Куда публикуются посты и в какие дни и часы. Публикация пока ручная.',
    add: 'Добавить канал',
    type: 'Тип',
    name: 'Название',
    url: 'Ссылка на канал',
    types: {
      telegram: 'Telegram',
      instagram: 'Instagram',
      vk: 'ВКонтакте',
      max: 'MAX',
      other: 'Другое',
    },
    active: 'Включён',
    inactive: 'Отключён',
    enable: 'Включить',
    disable: 'Отключить',
    disableConfirm: 'Отключить канал? Будет снято запланированных публикаций: {n}.',
    deleteConfirm: 'Удалить канал «{name}»?',
    empty: 'Каналов пока нет',
    emptyText: 'Добавьте Telegram-канал и Instagram-аккаунт блога.',
    rules: 'Ограничения: подпись {caption}, хештеги {hashtags}, медиа {media}',
    noLimit: 'без лимита',
    stats: 'Запланировано: {planned} · в истории: {history}',
    slots: {
      title: 'Сетка слотов',
      hint: 'Время в часовом поясе блога ({tz}).',
      time: 'Время',
      add: 'Добавить время',
      save: 'Сохранить сетку',
      empty: 'Слотов нет — очередь не сможет назначить время.',
      saved: 'Сетка сохранена, очередь перераскладывается.',
      remove: 'Убрать {time}',
      day: 'Слот {day} {time}',
    },
    compliance: {
      issues: {
        CAPTION_TOO_LONG: 'Подпись длиннее лимита: {length} из {limit}',
        TOO_MANY_HASHTAGS: 'Хештегов {count}, канал примет {limit} — лишние не попадут в подпись',
        TOO_MANY_MEDIA: 'Медиа {count}, канал примет {limit} за раз',
        FORMAT_NOT_ACCEPTED: 'Медиа №{position}: формат {ext} канал не принимает',
        FORMAT_REPLACED_BY_RENDITION: 'Медиа №{position}: вместо {ext} уйдёт JPEG-копия',
        NO_MEDIA: 'Без медиа',
        EMPTY_CAPTION: 'Пустая подпись',
      },
    },
  },
};

export const en: typeof ru = {
  channels: {
    title: 'Channels and slots',
    subtitle: 'Where posts go and on which days and hours. Publishing is manual for now.',
    add: 'Add channel',
    type: 'Type',
    name: 'Name',
    url: 'Channel link',
    types: {
      telegram: 'Telegram',
      instagram: 'Instagram',
      vk: 'VK',
      max: 'MAX',
      other: 'Other',
    },
    active: 'Enabled',
    inactive: 'Disabled',
    enable: 'Enable',
    disable: 'Disable',
    disableConfirm: 'Disable the channel? Scheduled publications to remove: {n}.',
    deleteConfirm: 'Delete channel “{name}”?',
    empty: 'No channels yet',
    emptyText: "Add the blog's Telegram channel and Instagram account.",
    rules: 'Limits: caption {caption}, hashtags {hashtags}, media {media}',
    noLimit: 'no limit',
    stats: 'Scheduled: {planned} · history: {history}',
    slots: {
      title: 'Slot grid',
      hint: 'Times are in the blog time zone ({tz}).',
      time: 'Time',
      add: 'Add time',
      save: 'Save grid',
      empty: "No slots — the queue can't assign times.",
      saved: 'Grid saved, the queue is being replanned.',
      remove: 'Remove {time}',
      day: 'Slot {day} {time}',
    },
    compliance: {
      issues: {
        CAPTION_TOO_LONG: 'Caption over the limit: {length} of {limit}',
        TOO_MANY_HASHTAGS: '{count} hashtags, the channel takes {limit} — the rest are dropped',
        TOO_MANY_MEDIA: '{count} media, the channel takes {limit} at once',
        FORMAT_NOT_ACCEPTED: 'Media #{position}: the channel does not accept {ext}',
        FORMAT_REPLACED_BY_RENDITION: 'Media #{position}: a JPEG copy goes instead of {ext}',
        NO_MEDIA: 'No media',
        EMPTY_CAPTION: 'Empty caption',
      },
    },
  },
};
